import api, { ResponseCallback } from '../services/api.service'

export interface CsvParseRequest {
  csv?: File
}

const routes = {
  parse: '/csv/parse'
}

export default {
  parse<CsvResponse> (payload: CsvParseRequest, callback: ResponseCallback<CsvResponse>) {
    api.postForm(routes.parse, payload, callback)
  }
}
